import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ContainerStatus = styled.div`
  width: 100%;
  height: 24px;
  padding: 4px 4px 4px 8px !important;

  gap: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  border-radius: 10rem;
  background-color: ${({status}) => status === "AT" ? '#2FBB6914' : '#FF525214'};

  >img {
    width: 12px;
    height: auto;
  }
`;